import { api } from '@/lib/api';
import {
  NotificationListResponse,
  NotificationResponse,
  NotificationQuery,
  CreateNotificationRequest,
  NotificationStats
} from '@troia-v3/types';

/**
 * Notification Service
 * Handles all notification-related API calls
 */
export const notificationService = {
  /**
   * Get current user's notifications with pagination and filters
   */
  async getMyNotifications(query?: NotificationQuery): Promise<NotificationListResponse> {
    const response = await api.get('/notifications/my', { params: query });
    return response.data.data;
  },

  /**
   * Get notification by ID
   */
  async getNotificationById(id: string): Promise<NotificationResponse> {
    const response = await api.get(`/notifications/${id}`);
    return response.data.data;
  },

  /**
   * Get unread notification count
   */
  async getUnreadCount(): Promise<number> {
    const response = await api.get('/notifications/unread-count');
    return response.data.data.unreadCount;
  },

  /**
   * Get notification statistics
   */
  async getStats(): Promise<NotificationStats> {
    const response = await api.get('/notifications/stats');
    return response.data.data;
  },

  /**
   * Create and send notification (admin/system use)
   */
  async createNotification(data: CreateNotificationRequest): Promise<NotificationResponse> {
    const response = await api.post('/notifications', data);
    return response.data.data;
  },

  /**
   * Mark notifications as read
   */
  async markAsRead(notificationIds: string[]): Promise<{ markedCount: number; unreadCount: number }> {
    const response = await api.put('/notifications/read', { notificationIds });
    return response.data.data;
  },

  /**
   * Archive notifications
   */
  async archiveNotifications(notificationIds: string[]): Promise<{ archivedCount: number }> {
    const response = await api.put('/notifications/archive', { notificationIds });
    return response.data.data;
  }
};
